export const MAX_TRADE_MARKS = 200;
export const MAX_PAGES_TO_LOAD = 10;
